<template>
    <div class="key-footer">
        <p id="count">Copyright &copy; {{date}} Touch Sprite Team</p>
    </div>
</template>
<script>
export default {
    data() {
        return {
			date: new Date().getFullYear()
		};
    }
};
</script>
<style lang="less" src="./index.less" scoped></style>


// WEBPACK FOOTER //
// src/common/footer/index.vue